import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M31.839 12c.104 1.097.153 2.175.16 3.212v.492q0 .157-.002.312c.033 2.493-.2 5.317-.863 8.108 0 0-.76 3.636-3.8 5.753V12z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M27.333 29.877a8 8 0 0 1-1.676.893c-.785.312-1.814.558-2.99.746V12h4.666z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M22.667 31.516c-1.4.224-3.008.364-4.667.434V12h4.667z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M30.55 6.133c.23.51.383.953.48 1.27-1.015 1.132-4.297 2.233-5.457 2.117-.321.368.593.495.098 1.133-.045.058-1.94.307-2.117 0-.262-.453.646-.583.414-1.425-2.592-.297-4.964-1.293-5.701-2.143q-.738-.85.565-1.085 3.54 1.073 4.477 1.162c.321-1.113 1.335-.76 1.474-.663.647.072.439.368.36.397-.207-.231-.752-.085-.467.302.87.375 4.496-.973 5.874-1.065",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagZmb = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagZmb_default = SvgFlagZmb;

export { FlagZmb_default as default };
